const FontFaceObserver = require("fontfaceobserver");
const debounce = require("lodash/debounce");
const _ = require("lodash");
import {trans} from "../../../../functions";


const debouncedModified = _.debounce((canvas, target, key, value) => {
    canvas.fire('object:modified', { action: 'value-update', target: target, key: key, value: value });
}, 500);

//todo move to /js/objects

(function(fabric) {

    /*
     * CurvedText object for fabric.js
     * @author Arjan Haverkamp (av01d)
     * @date January 2018
     */

    const textDefault = trans('storefront::image_editor.text_default');
    fabric.CurvedText = fabric.util.createClass(fabric.Object, {
        objectCaching: false,
        lockScalingFlip: true,
        type: 'curved-text',
        diameter: 250,
        kerning: 0,
        text: '',
        flipped: false,
        fill: '#000',
        fontFamily: 'Times New Roman',
        fontSize: 24, // in px
        fontWeight: 'normal',
        fontStyle: '', // "normal", "italic" or "oblique".
        cacheProperties: fabric.Object.prototype.cacheProperties.concat('text', 'diameter', 'kerning', 'flipped', 'fill', 'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'strokeStyle', 'strokeWidth'),
        strokeStyle: null,
        strokeWidth: 0,
        lockScalingX: false,
        lockScalingY: false,
        perPixelTargetFind: false,

        initialize: function(text, options) {
            options || (options = {});
            this.text = text;
            if (this.text === '' || this.text === null) {
                this.text = textDefault;
            }

            this.callSuper('initialize', options);
            this.set('lockUniScaling', true);

            // Draw curved text here initially too, while we need to know the width and height.
            var canvas = this.getCircularText();
            this._trimCanvas(canvas);
            this.set('width', canvas.width);
            this.set('height', canvas.height);
        },

        _getFontDeclaration: function()
        {
            return [
                // node-canvas needs "weight style", while browsers need "style weight"
                (fabric.isLikelyNode ? this.fontWeight : this.fontStyle),
                (fabric.isLikelyNode ? this.fontStyle : this.fontWeight),
                this.fontSize + 'px',
                (fabric.isLikelyNode ? ('"' + this.fontFamily + '"') : this.fontFamily)
            ].join(' ');
        },

        _trimCanvas: function(canvas)
        {
            var ctx = canvas.getContext('2d'),
                w = canvas.width,
                h = canvas.height,
                pix = {x:[], y:[]}, n,
                imageData = ctx.getImageData(0,0,w,h),
                fn = function(a,b) { return a-b };

            for (var y = 0; y < h; y++) {
                for (var x = 0; x < w; x++) {
                    if (imageData.data[((y * w + x) * 4)+3] > 0) {
                        pix.x.push(x);
                        pix.y.push(y);
                    }
                }
            }
            pix.x.sort(fn);
            pix.y.sort(fn);
            n = pix.x.length-1;

            w = pix.x[n] - pix.x[0];
            h = pix.y[n] - pix.y[0];
            var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

            canvas.width = w;
            canvas.height = h;
            ctx.putImageData(cut, 0, 0);
        },

        drawTextWithSpacing: function(ctx, text, x, y, letterSpacing) {
            for (let i = 0; i < text.length; i++) {
                let letter = text[i];
                ctx.fillText(letter, x, y);
                x += ctx.measureText(letter).width + letterSpacing;
            }
        },

        getStraightText: function () {
            var text = this.text,
                diameter = this.diameter,
                flipped = this.flipped,
                kerning = this.kerning,
                fill = this.fill,
                inwardFacing = true,
                startAngle = 0,
                canvas = fabric.util.createCanvasElement(),
                ctx = canvas.getContext('2d'),
                cw, // character-width
                x, // iterator
                clockwise = -1; // draw clockwise for aligned right. Else Anticlockwise

            canvas.width = ctx.measureText(text).width*this.fontSize*0.5;
            canvas.height = this.fontSize * 2.5;
            ctx.font = this._getFontDeclaration();
            ctx.fillStyle = fill;
            this.drawTextWithSpacing(ctx, text, 0, this.fontSize, this.kerning);  // Assuming 5 as the letter spacing

            return canvas;
        },

        // Source: http://jsfiddle.net/rbdszxjv/
        getCircularText: function()
        {
            var text = this.text,
                diameter = this.diameter,
                flipped = this.flipped,
                kerning = this.kerning,
                fill = this.fill,
                inwardFacing = true,
                startAngle = 0,
                canvas = fabric.util.createCanvasElement(),
                ctx = canvas.getContext('2d'),
                cw, // character-width
                x, // iterator
                clockwise = -1; // draw clockwise for aligned right. Else Anticlockwise

            if (text === '') {
                text = 'Empty text';
            }


            // console.log(diameter/this.fontSize);
            if ((diameter/this.fontSize) >= 50) {
                return this.getStraightText();
            }

            if (flipped) {
                startAngle = 180;
                inwardFacing = false;
            }

            ctx.imageSmoothingEnabled = true;

            startAngle *= Math.PI / 180; // convert to radians

            // Calc height of text in selected font:
            var d = document.createElement('div');
            d.style.fontFamily = this.fontFamily;
            d.style.whiteSpace = 'nowrap';
            d.style.fontSize = this.fontSize + 'px';
            d.style.fontWeight = this.fontWeight;
            d.style.fontStyle = this.fontStyle;
            d.textContent = text;
            document.body.appendChild(d);
            var textHeight = d.offsetHeight;
            document.body.removeChild(d);

            canvas.width = canvas.height = diameter;
            ctx.font = this._getFontDeclaration();

            // Reverse letters for center inward.
            if (inwardFacing) { text = text.split('').reverse().join('') };

            // Setup letters and positioning
            ctx.translate(diameter / 2, diameter / 2); // Move to center
            startAngle += (Math.PI * !inwardFacing); // Rotate 180 if outward
            ctx.textBaseline = 'middle'; // Ensure we draw in exact center
            ctx.textAlign = 'center'; // Ensure we draw in exact center

            // rotate 50% of total angle for center alignment
            for (x = 0; x < text.length; x++) {
                cw = ctx.measureText(text[x]).width;
                startAngle += ((cw + (x == text.length-1 ? 0 : kerning)) / (diameter / 2 - textHeight)) / 2 * -clockwise;
            }

            // Phew... now rotate into final start position
            ctx.rotate(startAngle);

            // Now for the fun bit: draw, rotate, and repeat
            for (x = 0; x < text.length; x++) {
                cw = ctx.measureText(text[x]).width; // half letter
                // rotate half letter
                ctx.rotate((cw/2) / (diameter / 2 - textHeight) * clockwise);
                // draw the character at "top" or "bottom"
                // depending on inward or outward facing

                // Stroke
                if (this.strokeStyle && this.strokeWidth) {
                    ctx.strokeStyle = this.strokeStyle;
                    ctx.lineWidth = this.strokeWidth;
                    ctx.miterLimit = 2;
                    ctx.strokeText(text[x], 0, (inwardFacing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2));
                }

                // Actual text
                ctx.fillStyle = fill;
                ctx.fillText(text[x], 0, (inwardFacing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2));

                ctx.rotate((cw/2 + kerning) / (diameter / 2 - textHeight) * clockwise); // rotate half letter
            }

            return canvas;
        },

        _set: function(key, value) {
            let oldValue = this[key];
            let oldFontSize = this['fontSize'];
            let oldDiameter = this['diameter'];

            if (key === 'text' && (value === '' || value === null)) {
                value = textDefault;
            }

            switch(key) {
                case 'scaleX':
                case 'scaleY':
                    window.imageEditor.store.text.fontSize = Math.round( oldFontSize * value );
                    let x = oldDiameter/oldFontSize;
                    window.imageEditor.store.text.diameter = x * window.imageEditor.store.text.fontSize;
                    return;
                    break;
                default:
                    this.callSuper('_set', key, value);

                    if ((key === 'diameter' || key === 'kerning' || key === 'fontSize' || key === 'flipped' || key === 'text' || key === 'fontFamily' || key === 'fill') && oldValue !== value) {
                        if (!this.canvas) return;

                        this.canvas.fire('diecut:clear');
                        debouncedModified(this.canvas, this, key, value);
                    }

                    break;
            }
        },

        _render: function(ctx)
        {
            var canvas = this.getCircularText();
            this._trimCanvas(canvas);

            this.set('width', canvas.width);
            this.set('height', canvas.height);

            ctx.drawImage(canvas, -this.width / 2, -this.height / 2, this.width, this.height);

            this.setCoords();
        },

        toObject: function(propertiesToInclude) {
            return this.callSuper('toObject', ['text', 'diameter', 'kerning', 'flipped', 'fill', 'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'strokeStyle', 'strokeWidth'].concat(propertiesToInclude));
        }
    });

    fabric.CurvedText.fromObject = function(object, callback) {
        const onFontLoad = () => {
            let curvedText = new fabric.CurvedText(object.text, object);

            if (callback) {
                callback(curvedText);
            }
        }

        let fontObserver = new FontFaceObserver(object.fontFamily);
        fontObserver.load(null).then(function () {
            onFontLoad();
        }).catch(function (e) {
            console.warn(`Font "${object.fontFamily}" is not available`, e);
            onFontLoad();
        });
    };

})(typeof fabric !== 'undefined' ? fabric : require('fabric').fabric);
